import {BaseModule} from "./base/base";
import Swiper from "swiper";
import { Navigation } from 'swiper/modules';

import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';

export class Sliders extends BaseModule {
    constructor() {
        super();

        this.initReviewsSlider();
        this.initPartnersSlider();
    }

    initReviewsSlider() {
        const reviewsWrapper = document.querySelector('.reviews-slider') as HTMLElement;
        if (reviewsWrapper) {
            const reviewsSlider = reviewsWrapper.querySelector('.swiper') as HTMLElement;
            if (reviewsSlider) {
                new Swiper(reviewsSlider, {
                    initialSlide: 0, // Default for mobile
                    slidesPerView: "auto",
                    centeredSlides: true,
                    spaceBetween: 16,
                    modules: [Navigation],
                    navigation: {
                        nextEl: reviewsWrapper.querySelector('.swiper-button__next') as any,
                        prevEl: reviewsWrapper.querySelector('.swiper-button__prev') as any,
                    },
                    breakpoints: {
                        768: {
                            initialSlide: 1, // Override for tablets and up
                            spaceBetween: 30,
                        },
                    },
                });
            }
        }
    }

    initPartnersSlider() {
        const partnersSlider = document.querySelector('.partners-slider') as HTMLElement;
        if (partnersSlider) {
            new Swiper(partnersSlider, {
                slidesPerView: "auto",
                spaceBetween: 30,
                modules: [Navigation],
                navigation: {
                    nextEl: partnersSlider.querySelector('.swiper-button-next') as any,
                    prevEl: partnersSlider.querySelector('.swiper-button-prev') as any,
                },
            });
        }
    }
}
